export function parseTranslations(translations){
    Object.keys(translations).forEach((localeKey)=>{
        Object.keys(translations[localeKey]).forEach((messageKey) => {
            if(!translations[localeKey][messageKey]){
                translations[localeKey][messageKey] = messageKey;
            }
        })
    });
    return translations;
}